import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        drls: '<'
    },
    template: `
         <p ng-repeat="drl in vm.drlList" style="margin-bottom: 1em; margin-top:0">
            {{ drl.departmentName }}, {{ drl.roleName }}, {{ drl.levelName }}
         </p>
         <span ng-if="vm.drlsLength > 3">...</span>
    `
})
export default class {
    constructor () {
        this.drlsLength = this.drls.length;
        this.drlList = this.drls.slice(0, 3);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/drl/partial/table/index.js